import { useSSOToken } from '../../../hooks/auth/ssoAuthHooks';

const SSOSignedIn = ({ children }) => {
  const { isSignedIn } = useSSOToken();

  return isSignedIn ? <>{children}</> : null;
};

export default SSOSignedIn;
